import React from 'react';
import styled from '@emotion/styled';
import { SideNavConsumer } from '../../context/SideNavContext';
import ChevronIcon from '../icons/ChevronIcon';

const SvgWrapper = styled.div<{ open: boolean; sideNavOpen: boolean }>`
  overflow: hidden;
  background: none;

  svg {
    width: 13px;
    height: 8px;
    margin-top: -0.15rem;
    margin-right: 0.25rem;

    path {
      fill: #c8dff0;
    }

    display: ${s => (s.sideNavOpen ? 'inline-block' : 'none')};
    transform: ${s => (s.sideNavOpen && s.open ? 'rotate(0deg)' : 'rotate(-90deg)')};
    transition: transform 250ms ease;
  }
`;

interface Props {
  open: boolean;
}

const SubNavToggle = (props: Props) => {
  return (
    <SideNavConsumer>
      {({ state }) => (
        <SvgWrapper sideNavOpen={state.isSideNavOpen} open={props.open}>
          <ChevronIcon />
        </SvgWrapper>
      )}
    </SideNavConsumer>
  );
};

export default SubNavToggle;
